var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "selected-category d-flex mt-2 my-md-3" }, [
        _c(
          "button",
          {
            staticClass:
              "ob1-card ob1-card-selected selected-category-image p-0 me-1",
            on: { click: _vm.backHandler },
          },
          [
            _c("span", {
              staticClass: "lead d-block mx-1",
              domProps: { innerHTML: _vm._s(_vm.title) },
            }),
            _vm._v(" "),
            _c("img", {
              staticClass: "pb-1",
              attrs: { src: _vm.image, alt: "" },
            }),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _vm._t("default"),
            _vm._v(" "),
            _c("Lien", {
              staticClass: "d-none d-sm-block",
              attrs: {
                "is-button": true,
                "is-mini": true,
                "is-link-arrow-back": true,
                label: _vm.backLinkLabel,
              },
              on: { click: _vm.backHandler },
            }),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _c("Lien", {
        staticClass: "d-sm-none",
        attrs: {
          "is-button": true,
          "is-mini": true,
          "is-link-arrow-back": true,
          label: _vm.backLinkLabel,
        },
        on: { click: _vm.backHandler },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }